import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastSuccess } from '@/helpers';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateTimeOffQueries } from '@/modules/common/utils/query-invalidation';

import { cancelTimeOffRequest } from '../api/time-offs.api';

export const useCancelTimeOff = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('authenticated.timeOff');
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: (id: number) => cancelTimeOffRequest(id),
    onSuccess: async () => {
      await invalidateTimeOffQueries(queryClient);
      displayToastSuccess(t('toasts.cancelSuccess'));
      onSuccess?.();
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(error, 'toasts.cancelError');
    },
  });
};
